module.exports = __webpack_public_path__ + "img/fb.5875721e.svg";